import { useIsCanvasUnited } from '../../../../hooks/useIsCanvasUnited';
import { useContext } from 'react';
import { ReserveSpaceForPanelsCtx } from './ReserveSpaceForPanelsCtx';

/**
 * Product definition:
 * 1. Canvas View
 * Default panel state: Minimized
 * Do not persist panel state after user closes panel (No memory within session, No memory across sessions)
 *
 * 2. Standalone App View
 * Default panel state: Maximized
 */
export const useExpandedMode = () => {
  const isCanvasUnited = useIsCanvasUnited();
  const { isLocalExpandedMode, setIsLocalExpandedMode } = useContext(ReserveSpaceForPanelsCtx);

  return {
    resetPanelWidthOnClose: isCanvasUnited ? () => setIsLocalExpandedMode(false) : undefined,
    isExpandedMode: isCanvasUnited ? isLocalExpandedMode : true,
    setIsExpandedMode: isCanvasUnited ? setIsLocalExpandedMode : () => {}, //not supported
    isCanvasUnited,
  };
};
